<div class="staff-parameter-block">
    <h3>Parámetros</h3>
    <div class="parameter-item-list">
        <div class="parameter-each file-uploader">
            <mat-label class="upload-label">Fichero</mat-label>
            <div class="upload-wrapper">
                <input type="file" class="file-input" [formControl]="importExcel" #fileUpload accept="{{FileFormatEnum.StaffImportController}}"
                    (change)="onFileChange($event.target.files)" multiple="false">
                <div class="file-upload">
                    <button mat-raised-button color="accent" class="upload-btn"
                        (click)="fileUpload.value='';fileUpload.click()">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                </div>
                <span class="no-msg" *ngIf="fileChosen">{{fileChosenName}}</span>
            </div>
        </div>

    </div>
    <div class="parameter-item-list">
        <div class="parameter-each fomatter">
            <mat-label class="label">Formato</mat-label>
            <mat-form-field appearance="fill">
                <mat-select [formControl]="importTemplateDropdown" (selectionChange)="onChangeImportTemplate($event)">
                    <mat-option *ngFor="let item of importTemplates" [value]="item.importacionId"
                        placehoder="Seleccione">
                        {{item.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="button-wrapper">
                <button (click)="openFormatoModal()">
                    <mat-icon>save</mat-icon>
                </button>
                <button (click)="deleteImportTemplate()">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
        </div>
        <div class="parameter-each width-d">
            <mat-label>Tipo de importación</mat-label>
            <mat-form-field appearance="fill">
                <mat-select placeholder="Plantillas con totales" [formControl]="tipoImportacion">
                    <mat-option value="1" selected>Plantillas con totales</mat-option>
                    <mat-option value="2">Plantillas completas</mat-option>
                    <mat-option value="3">Totalizar plantillas</mat-option>
                    <mat-option value="4">Cuentas proyecto Eulen</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="parameter-item-list">
        <div class="parameter-each width-s">
            <mat-label>Primera fila</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput [formControl]="primeraFila" type="number" value="2" min="1" max="20000">
                <mat-error *ngIf="primeraFila && primeraFila.invalid">
                    <span class="validation-span">Inválido</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="parameter-each width-s">
            <mat-label>Columna clave</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput type="number" [formControl]="columnaClave" value="1" min="1" max="200">
                <mat-error *ngIf="columnaClave && columnaClave.invalid">
                    <span class="validation-span">Inválido</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="parameter-each width-s">
            <mat-label>Nº de hojas</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput type="number" [formControl]="hojas" value="1" min="1" max="16">
                <mat-error *ngIf="hojas && hojas.invalid">
                    <span class="validation-span">Inválido</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="parameter-each width-n">
            <mat-label>Mes</mat-label>
            <mat-form-field appearance="fill">
                <mat-select [formControl]="mes">
                    <mat-option [value]="1">Enero</mat-option>
                    <mat-option [value]="2">Febrero</mat-option>
                    <mat-option [value]="3">Marzo</mat-option>
                    <mat-option [value]="4">Abril</mat-option>
                    <mat-option [value]="5">Mayo</mat-option>
                    <mat-option [value]="6">Junio</mat-option>
                    <mat-option [value]="7">Julio</mat-option>
                    <mat-option [value]="8">Agosto</mat-option>
                    <mat-option [value]="9">Septiembre</mat-option>
                    <mat-option [value]="10">Octubre</mat-option>
                    <mat-option [value]="11">Noviembre</mat-option>
                    <mat-option [value]="12">Diciembre</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="parameter-each width-s">
            <mat-label>Año</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput type="number" [formControl]="anyo" [min]="minimumYear">
                <mat-error *ngIf="anyo && anyo.invalid">
                    <span class="validation-span">Inválido</span>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</div>